<template>
  <div
    ref="showBox"
    :style="[width>0 ? {width:width+'px'} : '',height>0 ? {height:height+'px'} : '']"
    class="showBox"
  >
    <div
      ref="contentBox"
      :style="{transform:transform}"
      class="contBox"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default{
    props: {
        scale: {
            type: Number,
            default: 1
        },
        world: {
            type: String,
            default: ""
        }
    },
    data(){
        return {
            width:0,
            height:0,
            transform:"scale(1)"
        };
    },  //接收一个参数为缩放倍数
    watch: {
        world:{
            handler(val, oldVal){
                this.resetWidthHeight();
            },
        },
    },
    mounted() {
        this.setWidthHeight();
    },
    methods:{
        setWidthHeight(){
            setTimeout( () => {
                this.transform=`scale(${this.scale})`;
                let boundClient=this.$refs.contentBox.getBoundingClientRect();
                this.width=Math.ceil(boundClient.width*this.scale);
                // console.log(boundClient.width,this.width);
                // this.height=Math.ceil(boundClient.height*this.scale);
            },0);
        },
        resetWidthHeight(){
            setTimeout( () => {
                let boundClient=this.$refs.contentBox.getBoundingClientRect();
                this.width=boundClient.width;
                // this.height=boundClient.height;
            },0);
        }
    }
};
</script>
<style lang="stylus" scoped>
    .showBox{
        
        display: inline-block;
    }
    .contBox{
        
        display: inline-block;
        transform-origin: left center;
    }
</style>


// WEBPACK FOOTER //
// src/components/native/pay/comp/SetScale.vue